import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, CheckCircle2, Mail, Phone, User } from "lucide-react";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/messages").then((r) => setMessages(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const open = async (m) => {
    setSelected(m);
    if (!m.read) {
      try {
        await api.put(`/messages/${m.id}/read`);
        setMessages((prev) => prev.map((x) => (x.id === m.id ? { ...x, read: true } : x)));
      } catch (_e) {
        // ignore
      }
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Mesaj silinsin mi?")) return;
    try {
      await api.delete(`/messages/${id}`);
      toast.success("Silindi");
      if (selected?.id === id) setSelected(null);
      load();
    } catch { toast.error("Silme hatası"); }
  };

  return (
    <div className="p-8 lg:p-12" data-testid="admin-messages-page">
      <div className="mb-10">
        <div className="section-label mb-3">İletişim</div>
        <h1 className="font-heading text-3xl lg:text-4xl text-white tracking-[0.05em]">Gelen Mesajlar ({messages.length})</h1>
      </div>

      <div className="grid lg:grid-cols-5 gap-6">
        <div className="lg:col-span-2 space-y-2 max-h-[70vh] overflow-y-auto">
          {messages.length === 0 && <div className="text-white/40 text-center py-12 border border-dashed border-[#1F2937]">Mesaj yok</div>}
          {messages.map((m) => (
            <button
              key={m.id}
              onClick={() => open(m)}
              data-testid={`message-item-${m.id}`}
              className={`w-full text-left p-4 border transition-colors ${
                selected?.id === m.id ? "border-[#C9A961] bg-[#C9A961]/5" : "border-[#1F2937] hover:border-[#C9A961]/40"
              }`}
            >
              <div className="flex items-center gap-2 mb-1">
                {!m.read && <span className="w-2 h-2 rounded-full bg-[#C9A961]"></span>}
                <div className="text-white font-semibold truncate flex-1">{m.name}</div>
                <div className="text-[10px] text-white/40 uppercase tracking-widest">{new Date(m.created_at).toLocaleDateString("tr-TR")}</div>
              </div>
              <div className="text-xs text-white/50 truncate">{m.subject || m.message.slice(0, 60)}</div>
            </button>
          ))}
        </div>

        <div className="lg:col-span-3 yk-card p-8 min-h-[400px]">
          {!selected ? (
            <div className="h-full flex items-center justify-center text-white/40 text-sm uppercase tracking-widest">
              <Mail className="w-6 h-6 mr-3" /> Bir mesaj seçin
            </div>
          ) : (
            <>
              <div className="flex items-start justify-between mb-6 pb-6 border-b border-[#1F2937]">
                <div>
                  <div className="flex items-center gap-2 mb-3">
                    <User className="w-4 h-4 text-[#C9A961]" />
                    <div className="font-heading text-xl text-white tracking-widest">{selected.name}</div>
                    {selected.read && <CheckCircle2 className="w-4 h-4 text-[#C9A961]" />}
                  </div>
                  <div className="flex flex-wrap gap-4 text-xs text-white/60">
                    {selected.email && <div className="flex items-center gap-1.5"><Mail className="w-3 h-3" /> {selected.email}</div>}
                    {selected.phone && <div className="flex items-center gap-1.5"><Phone className="w-3 h-3" /> {selected.phone}</div>}
                  </div>
                </div>
                <button onClick={() => remove(selected.id)} className="p-2 text-white/60 hover:text-red-400" data-testid="delete-message-btn"><Trash2 className="w-4 h-4" /></button>
              </div>
              {selected.subject && (
                <div className="mb-4">
                  <div className="section-label mb-2">Konu</div>
                  <div className="text-white">{selected.subject}</div>
                </div>
              )}
              <div>
                <div className="section-label mb-2">Mesaj</div>
                <div className="text-white/80 leading-relaxed whitespace-pre-line">{selected.message}</div>
              </div>
              <div className="mt-8 pt-6 border-t border-[#1F2937] text-xs text-white/40">
                {new Date(selected.created_at).toLocaleString("tr-TR")}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
